/*
* content config
* */

import './content-styles.css'